module.exports = __webpack_public_path__ + "img/cloud_server.7a9d622d.svg";